export default __webpack_public_path__ + "static/media/Q_Quadro.a4a31a06.mp3";